import { useCallback } from 'react';
import { getGoogleRedirectUrl, GOOGLE_CLIENT_KEY, isSnsSignOut, SNS_AUTH_DATA_KEY } from 'app/libs/snsUtils';
import { setSessionItem } from 'app/libs/storageUtils';
import mobileAppBridge from 'app/libs/MobileAppBridge';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import { v4 as uuidv4 } from 'uuid';
import qs from 'query-string';

export default function useAuthGoogle() {
	const ua = useSsrUserAgent();

	/**
	 * 함수 호출시 아래와 같은 타입으로 파라미터를 전달해야 합니다.
	 * snsAuthorizeForTypes.LOGIN,
	 * snsAuthorizeForTypes.MY_INFO_ACCESS,
	 * snsAuthorizeForTypes.CONNECT_LOGIN
	 */
	const authorizeGoogle = useCallback(
		async (type, options) => {
			if (!type) throw new Error('인증 타입을 전달해 주세요.');

			try {
				const state = uuidv4();
				setSessionItem(SNS_AUTH_DATA_KEY, { type, state, options });

				if (ua().isApp) {
					mobileAppBridge().verifyGoogle();
				} else {
					const params = {
						client_id: GOOGLE_CLIENT_KEY,
						scope: 'profile email',
						ux_mode: 'redirect',
						redirect_uri: getGoogleRedirectUrl(),
						response_type: 'id_token',
						state,
						nonce: state,
						...(ua().isPc && isSnsSignOut('GOOGLE') && { prompt: 'select_account' }),
					};
					window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${qs.stringify(params)}`;
				}
			} catch (err) {
				console.error(err);
			}
		},
		[ua],
	);

	return { authorizeGoogle };
}
